import { render, staticRenderFns } from "./EventHotelInfo.vue?vue&type=template&id=0964bf0e&"
import script from "./EventHotelInfo.vue?vue&type=script&lang=js&"
export * from "./EventHotelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports